/**
 * SOURCE UNIQUE du sous-chemin de déploiement de l'application.
 * Production : https://www.giordan.fr/vv/ (dossier OVH /www/vv/).
 * L'ancienne visite reste à /360/ et n'est jamais touchée.
 *
 * Fichier sans aucun import : consommé aussi bien par next.config.ts que
 * par le code applicatif. Équivalent côté scripts Node : scripts/site.mjs
 * (à garder synchronisé).
 */
export const BASE_PATH = "/vv";
